// Submission boundary for the CoreX waitlist (WAIT-4B: live API).
// buildWaitlistPayload produces the exact WAIT-3A.2 request contract.
// submitWaitlist performs the real POST via the centralized API helper.
import { OTHER_CODE } from "@/data/waitlistOptions";
import { submitWaitlistSignup } from "@/lib/waitlistApi";

const trimOrNull = (v) => {
  const t = (v || "").trim();
  return t === "" ? null : t;
};

// Builds the exact backend request shape. Other-text fields are null unless the
// matching Other option is selected. country/region are NOT launch-form fields
// and are intentionally omitted.
export function buildWaitlistPayload(values) {
  const personaCodes = values.personaCodes || [];
  const sportCodes = values.sportCodes || [];
  const otherPersonaSelected = personaCodes.includes(OTHER_CODE);
  const otherSportSelected = sportCodes.includes(OTHER_CODE);
  const attribution = values.attribution || {};

  return {
    email: (values.email || "").trim(),
    first_name: (values.firstName || "").trim(),
    last_name: trimOrNull(values.lastName),
    organization_name: trimOrNull(values.organizationName),
    sport_codes: sportCodes,
    persona_codes: personaCodes,
    other_sport_text: otherSportSelected ? trimOrNull(values.otherSportText) : null,
    other_persona_text: otherPersonaSelected
      ? trimOrNull(values.otherPersonaText)
      : null,
    marketing_consent: !!values.marketingConsent,
    utm_source: attribution.utm_source ?? null,
    utm_medium: attribution.utm_medium ?? null,
    utm_campaign: attribution.utm_campaign ?? null,
    utm_content: attribution.utm_content ?? null,
    landing_page_path: attribution.landing_page_path ?? null,
    website: values.website || "",
  };
}

// Performs the live submission. Returns the classified API result.
export async function submitWaitlist(values) {
  const payload = buildWaitlistPayload(values);
  return submitWaitlistSignup(payload);
}
